import { useState, useEffect, useCallback } from 'react';

// Key to track if user just logged in
const JUST_LOGGED_IN_KEY = 'just_logged_in';

interface UseWelcomeAnimationReturn {
  showWelcome: boolean;
  completeWelcome: () => void;
}

// Call this function after successful login
export const setJustLoggedIn = () => {
  sessionStorage.setItem(JUST_LOGGED_IN_KEY, 'true');
};

const useWelcomeAnimation = (): UseWelcomeAnimationReturn => {
  const [showWelcome, setShowWelcome] = useState(false);

  // Check if user just logged in
  useEffect(() => {
    const justLoggedIn = sessionStorage.getItem(JUST_LOGGED_IN_KEY);
    if (justLoggedIn) {
      setShowWelcome(true);
    }
  }, []);

  const completeWelcome = useCallback(() => {
    sessionStorage.removeItem(JUST_LOGGED_IN_KEY);
    setShowWelcome(false);
  }, []);

  return {
    showWelcome,
    completeWelcome,
  };
};

export default useWelcomeAnimation;
